import {Cureus} from '../Cureus';

Cureus.EmailCampaignIndex = {};

//= require_tree ./EmailCampaignIndex
